import {gql} from 'graphql-request';
import {SaasIdentifier} from "src/types/Saas";

// "counts" of the number of apps that have a particular property
export const appSummaryQuery = gql`
  query AppSummary($clientBoolExp: client_bool_exp) {
   app_summary(
     where: {
       client_saas: {
         client: $clientBoolExp,
         saas: {
           name: {_eq:${SaasIdentifier.microsoft365}}
         }
       }
     }
   ) {      
      lessThan5_count
      fiveTo10_count
      tenTo25_count
      over25_count
      is_enterprise
      calendar_access
      file_access
      write_access
      email_access
      total_count
    }
  }
`;

// Returns all apps in use at a customer site.
// Provides user count and "access" counts for each app.
export const userAppCountQuery = gql`
  query UserAppCount($clientBoolExp: client_bool_exp) {
     app(
       where: {
         client_saas: {
           client: $clientBoolExp,
           saas: {
             name: {_eq:${SaasIdentifier.microsoft365}}
           }
         }
       },
       order_by: {latest_saas_users_aggregate: {count: desc}}
    ) {
      pub_id
      external_id
      application_id
      display_name
      is_enterprise
      is_admin_consented
      user_count: latest_saas_users_aggregate {
        aggregate {
          count
        }
      }
      access {
        write_access
        calendar_access
        file_access
        email_access
      }
    }
  }
`;

// users of a particular app:
export const usersForAppQuery = gql`
  query UsersForApp($pub_id: uuid, $clientBoolExp: client_bool_exp) {
    app(where: {
         pub_id: {_eq :$pub_id},
         client_saas: { client: $clientBoolExp }
      }) {
      pub_id
      display_name
      is_enterprise
      latest_saas_users {
        created_datetime
        last_login{
          login_datetime
        }
        latest_saas_user {
          pub_id
          name
          email
          privilege_level
          generic_user {
            pub_id
          }
        }
      }
    }
  }
`;

const appsForUserFragment = gql`
  fragment App on latest_saas_user {
      pub_id
      name
      email
      generic_user {
        pub_id
      }
      apps{
        last_login{
          login_datetime
        }
        app{
          pub_id
          external_id
          application_id
          display_name
          is_enterprise
          is_admin_consented
          latest_saas_users_aggregate {
            aggregate {
              count
            }
          } 
          access {
            write_access
            calendar_access
            file_access
            email_access
          }
        }
      }
  }
`;

export const appInfoQuery = gql`query AppInfo($pub_id: uuid, $clientBoolExp: client_bool_exp) {
    app(where: {
          pub_id: {_eq :$pub_id},
          client_saas: {
            client: $clientBoolExp
          }
        }) {
      pub_id
      display_name
      is_enterprise
      access {
       write_access
       calendar_access
       file_access
       email_access
      }
    }
   }`;


export const appsForGenericUserQuery = gql`
  query AppsForUser($pub_id: uuid, $clientBoolExp: client_bool_exp) {
    latest_saas_user(where: {
       generic_user: {pub_id: {_eq :$pub_id}},
       client: $clientBoolExp
    }){
      ...App
    }
  }
 ${appsForUserFragment}
`;
